export const categoryTranslations = {
  "Home Appliances": "categories.home_appliances",
  "Home & Garden": "categories.home_garden",
  "Jewelry & Accessories": "categories.jewelry_accessories",
  Accessories: "categories.accessories",
  "Women's Clothing": "categories.womens_clothing",
  "Tech Accessories": "categories.tech_accessories",
  "Men's Clothing": "categories.mens_clothing",
  Underwear: "categories.underwear",
  "Novelty & Special Use": "categories.novelty_special_use",
  "Sports Clothing": "categories.sports_clothing",
  "Motorcycle Equipments & Parts": "categories.motorcycle_equipments_parts",
  "Computer & Office": "categories.computer_office",
  "Home Improvement": "categories.home_improvement",
  "Sports & Entertainment": "categories.sports_entertainment",
  "Toys & Hobbies": "categories.toys_hobbies",
  "Security & Protection": "categories.security_protection",
  "Automobiles, Parts & Accessories":
    "categories.automobiles_parts_accessories",
  "Lights & Lighting": "categories.lights_lighting",
  "Consumer Electronics": "categories.consumer_electronics",
  "Beauty & Health": "categories.beauty_health",
  "Bath & Beauty": "categories.beauty_health",
  "Weddings & Events": "categories.weddings_events",
  Shoes: "categories.shoes",
  Pets: "categories.pet_products",
  "Electronic Components & Supplies":
    "categories.electronic_components_supplies",
  "Phones & Telecommunications": "categories.phones_telecommunications",
  Tools: "categories.tools",
  "Mother & Kids": "categories.mother_kids",
  Watches: "categories.watches",
  "Luggage & Bags": "categories.luggage_bags",
  "Hair Extensions & Wigs": "categories.hair_extensions_wigs",
};
